window.addEventListener('load', function() {
    // YOUR JS CODE GOES HERE - After Page is loaded
});

document.addEventListener("DOMContentLoaded", function () {

  function setupAutoCarouselScroll() {
  const carousel = document.querySelector('[id^="complementary-products-carousel-"]');
  if (!carousel || typeof carousel.next !== 'function') return;

  if (carousel.__autoscroll) clearInterval(carousel.__autoscroll);

  carousel.__autoscroll = setInterval(() => {
    const selectedIndex = carousel.selectedIndex;
    const lastIndex = carousel.cells.length - 1;

    if (selectedIndex >= lastIndex) {
      carousel.select(0);
    } else {
      carousel.next({ instant: false });
    }
  }, 4000);

  carousel.onmouseenter = () => clearInterval(carousel.__autoscroll);
  carousel.onmouseleave = () => {
    carousel.__autoscroll = setInterval(() => {
      const selectedIndex = carousel.selectedIndex;
      const lastIndex = carousel.cells.length - 1;

      if (selectedIndex >= lastIndex) {
        carousel.select(0);
      } else {
        carousel.next({ instant: false });
      }
    }, 4000);
  };
}


  function observeCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const observer = new MutationObserver((mutationsList, observer) => {
      const newCarousel = drawer.querySelector('[id^="complementary-products-carousel-"]');
      if (newCarousel) {
        setupAutoCarouselScroll();
      }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

    observeCartDrawer();
    setupAutoCarouselScroll();
});
